/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type ModerationActionsContainer_story = {
    readonly id: string;
    readonly settings: {
        readonly mode: STORY_MODE;
    };
    readonly " $fragmentRefs": FragmentRefs<"CopyCommentEmbedCodeContainer_story">;
    readonly " $refType": "ModerationActionsContainer_story";
};
export type ModerationActionsContainer_story$data = ModerationActionsContainer_story;
export type ModerationActionsContainer_story$key = {
    readonly " $data"?: ModerationActionsContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionsContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CopyCommentEmbedCodeContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'e244a83d3f6b671e8f1d00b9a54c0abc';
export default node;
